<template>
  <v-container>
    <v-card :dark="config.dark_background" :color="config.background_dark">
      <v-card-title>
        By using the website you are agreeing to the following conditions.
      </v-card-title>
      <v-container>
        <legal-modal>
        </legal-modal>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import config from '@/config/config'
import LegalModal from '@/components/LegalModal'
export default {
  name: 'legal',
  data() {
    return {
      config
    }
  },
  methods: {
    navigateTo (route) {
      this.$router.push(route)
    },
    logOut () {
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setUser', null)
      this.$router.push({
        name: 'root'
      })
    }
  },
  components: {
    LegalModal
  }
}
</script>

<style scoped>

</style>